import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Modal from '@components/modal/Modal'
import Loader from '@components/loader/Loader'

interface Props {
  title?: string
}

const Component = ({ title }: Props) => {
  return (
    <Container>
      <Loader color={theme.colors.background} />
      {!!title && <Title>{title}</Title>}
    </Container>
  )
}

const ModalLoader = {
  open: (props: Props) =>
    Modal.open({
      Content: () => <Component {...props} />,
      cancel: false,
    }),
  close: Modal.close,
}

export default ModalLoader

const Container = styled(View)`
  align-items: center;
  max-width: 300px;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  color: ${(props) => props.theme.colors.background};
  margin-top: 10px;
`
